<div class="card p-2">
  <div class="d-flex justify-content-start mb-3">
    <button class="btn btn-secondary me-3" (click)="showCalendar.emit()">Back to Calendar</button>
    <div class="d-flex justify-content-center flex-column">
      <h3>{{ header }}</h3>
    </div>
  </div>
  <table class="table table-connectpay">
    <thead>
      <tr>
        <th>Name</th>
        <th>Date Requested</th>
        <th>Type</th>
        <th>Time Off</th>
        <th>Status</th>
        <th>Request Details</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let request of requests">
        <td>{{ request.RequesterName }}</td>
        <td>{{ request.DateRequested | date: 'MM/dd/YY' }}</td>
        <td>
          <span *ngIf="request.Request.TimeOffRequestType == RequestTypes.SingleDay"
            >Single Day</span
          >
          <span *ngIf="request.Request.TimeOffRequestType == RequestTypes.PartialDay"
            >Partial Day</span
          >
          <span *ngIf="request.Request.TimeOffRequestType == RequestTypes.MultipleDays"
            >Multiple Days</span
          >
        </td>
        <td>
          <span *ngIf="request.Request.TimeOffRequestType == RequestTypes.SingleDay">{{
            request.Request.StartDate | date: 'MM/dd/YY'
          }}</span>
          <span *ngIf="request.Request.TimeOffRequestType == RequestTypes.PartialDay">
            {{ request.Request.StartDate | date: 'MM/dd/YY' }}
            <span
              >{{ request.Request.StartTime | date: 'shortTime' }} -
              {{ request.Request.EndTime | date: 'shortTime' }}</span
            >
          </span>
          <span *ngIf="request.Request.TimeOffRequestType == RequestTypes.MultipleDays">
            {{ request.Request.DateRange.Start | date: 'MM/dd/YY' }} -
            {{ request.Request.DateRange.End | date: 'MM/dd/YY' }}
          </span>
        </td>
        <td>
          <span *ngIf="!request.Declined" class="pendingText">
            <span *ngIf="request.EditedByRequester || request.Pending">Pending</span>
            <span *ngIf="request.EditedByApprover">Pending Change</span>
          </span>
          <span *ngIf="request.Declined" class="text-danger">Declined</span>
        </td>
        <td>
          <button
            class="btn btn-tertiary"
            style="padding: 12px 22px"
            (click)="reviewRequest.emit(request)">
            Review Request
          </button>
        </td>
      </tr>
      <tr *ngFor="let request of deleted">
        <td>{{ request.PersonName }}</td>
        <td>{{ request.DateApproved | date: 'MM/dd/YY' }}</td>
        <td>
          <span *ngIf="request.RequestType == RequestTypes.SingleDay">Single Day</span>
          <span *ngIf="request.RequestType == RequestTypes.PartialDay">Partial Day</span>
          <span *ngIf="request.RequestType == RequestTypes.MultipleDays">Multiple Days</span>
        </td>
        <td>
          <span *ngIf="request.RequestType == RequestTypes.SingleDay">{{
            request.StartDate | date: 'MM/dd/YY'
          }}</span>
          <span *ngIf="request.RequestType == RequestTypes.PartialDay">
            {{ request.StartDate | date: 'MM/dd/YY' }}
            <span
              >{{ request.StartDate | date: 'shortTime' }} -
              {{ request.EndDate | date: 'shortTime' }}</span
            >
          </span>
          <span *ngIf="request.RequestType == RequestTypes.MultipleDays">
            {{ request.StartDate | date: 'MM/dd/YY' }} - {{ request.EndDate | date: 'MM/dd/YY' }}
          </span>
        </td>
        <td>
          <span class="text-danger">Declined</span>
        </td>
        <td>
          <button
            class="btn btn-tertiary"
            style="padding: 12px 22px"
            (click)="reviewDeclinedRequest.emit(request)">
            Review Request
          </button>
        </td>
      </tr>
      <tr *ngFor="let request of edited">
        <td>{{ request.EditedRecord.PersonName }}</td>
        <td>{{ request.EditedRecord.DateApproved | date: 'MM/dd/YY' }}</td>
        <td>
          <span *ngIf="request.EditedRecord.RequestType == RequestTypes.SingleDay">Single Day</span>
          <span *ngIf="request.EditedRecord.RequestType == RequestTypes.PartialDay"
            >Partial Day</span
          >
          <span *ngIf="request.EditedRecord.RequestType == RequestTypes.MultipleDays"
            >Multiple Days</span
          >
        </td>
        <td>
          <span *ngIf="request.EditedRecord.RequestType == RequestTypes.SingleDay">{{
            request.EditedRecord.StartDate | date: 'MM/dd/YY'
          }}</span>
          <span *ngIf="request.EditedRecord.RequestType == RequestTypes.PartialDay">
            {{ request.EditedRecord.StartDate | date: 'MM/dd/YY' }}
            <span
              >{{ request.EditedRecord.StartDate | date: 'shortTime' }} -
              {{ request.EditedRecord.EndDate | date: 'shortTime' }}</span
            >
          </span>
          <span *ngIf="request.EditedRecord.RequestType == RequestTypes.MultipleDays">
            {{ request.EditedRecord.StartDate | date: 'MM/dd/YY' }} -
            {{ request.EditedRecord.EndDate | date: 'MM/dd/YY' }}
          </span>
        </td>
        <td>
          <span class="pendingText">Pending Change</span>
        </td>
        <td>
          <button
            class="btn btn-tertiary"
            style="padding: 12px 22px"
            (click)="reviewEditedRequest.emit(request)">
            Review Request
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
